import React from 'react';
import PropTypes from 'prop-types';

import AccessibleIcon from '../common/AccessibleIcon';

const propTypes = {
    tagRecord: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        tag: PropTypes.string.isRequired,
        description: PropTypes.string,
    }),
    onDeleteTag: PropTypes.func,
};

const defaultProps = {
    onDeleteTag: null,
};

function TagListItem(props) {
    return (
        <li className="termListing">
            <div className="termListing__termContainer">
                {props.tagRecord.tag}
                {!!props.tagRecord &&
                    <div className="termDescription margin-top-sm">
                        {props.tagRecord.description}
                    </div>
                }
            </div>
            {!!props.onDeleteTag &&
                <button className="bare-text-button glyph termListing__control" onClick={props.onDeleteTag}>
                    <AccessibleIcon label="Delete">
                        <span className="fa fa-remove" aria-hidden={true} />
                    </AccessibleIcon>
                </button>
            }
        </li>
    );
}

TagListItem.propTypes = propTypes;
TagListItem.defaultProps = defaultProps;

export default TagListItem;